import type { IconData } from '@stacksjs/iconify-core'

export const shieldF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.02 11.02 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shieldF
